import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=1963e88e&scoped=true&"
import script from "./Tel.vue?vue&type=script&lang=js&"
export * from "./Tel.vue?vue&type=script&lang=js&"
import style0 from "./Tel.vue?vue&type=style&index=0&id=1963e88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963e88e",
  null
  
)

export default component.exports